/* eslint-disable indent */
import { CreateProposal } from 'features/Proposal';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

function CreateProposalPage() {
    return (
        <LayoutProvider>
            <Layout>
                <CreateProposal />
            </Layout>
        </LayoutProvider>
    );
}

export default CreateProposalPage;
